import yall from 'yall-js';

// Fire up yall
document.addEventListener('DOMContentLoaded', () => yall({ threshold: 350 }));
